
import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import NavDropdown from 'react-bootstrap/NavDropdown';

import LogoHeader from '../Assets/Image/PradhLogo.png';
// import LogoHeader from '../Assets/Image/pradhmanagementsolution.png';
import '../Assets/Css/webheader.css';
import { MdMarkEmailRead } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";

import {
  FaHome,
  FaInfoCircle,
  FaBroom,
  FaWrench,
  FaHardHat,
  FaPaintRoller,
  FaBug,
  FaUsers,
  FaCogs,
  FaPhoneAlt,
  FaAngleDown

} from 'react-icons/fa';
import { MdOutlinePlumbing } from 'react-icons/md';
import { GiSteelDoor } from 'react-icons/gi';



function WebHeader() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  const handleNavClick = () => {
    setExpanded(false); // Collapse navbar on link click
  };
  const location = useLocation();
  const isServicesActive = location.pathname.startsWith('/services') ||
    location.pathname === '/cleaningservices' ||
    location.pathname === '/maintenanceservice' ||
    location.pathname === '/civilconstructionser' ||
    location.pathname === '/mepservice' ||
    location.pathname === '/pestbirdcontrol' ||
    location.pathname === '/paintingandcoating' ||
    // location.pathname === '/pestbirdcontrol' ||
    location.pathname === '/manpowerandhousekeeping' ||
    location.pathname === '/fabricationservices';

  const [showDropdown, setShowDropdown] = useState(false);



  const handleToggleManually = (e) => {
    e.preventDefault(); // stop default toggle behavior
    setShowDropdown(!showDropdown);
  };



  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);

  return (
    <>


      <div className="top-header">
        <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div className="d-flex flex-wrap align-items-center email-info">
            <a
              href="https://wa.me/8482922662"
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex text-white align-items-center gap-2"
              style={{ textDecoration: 'none' }}
            >
              <FaPhoneSquareAlt className="d-none d-md-flex" />
              +918482922662
            </a>
            <span className="mx-2 text-white">|</span>
            <a
              href="mailto:pradhmspl@gmail.com"
              className="d-flex text-white align-items-center gap-2"
              style={{ textDecoration: 'none' }}
            >
              <MdMarkEmailRead className="d-none d-md-flex" />
              pradhmspl@gmail.com
            </a>
          </div>

          <div className="d-none d-md-flex mt-2 mt-md-0">
            <Button
              className="servicesbtn"
              size="sm"
              variant="primary"
              href="/cleaningservices"
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                borderRadius: '5px',
                backgroundColor: 'white',
                border: '1px solid #00B5F3',
                color: '#00B5F3',
                fontWeight: 'bold'
              }}
            >
              Our Services
            </Button>
          </div>
        </Container>
      </div>


      {/* Main Navbar */}
      <Navbar expand="lg" className="custom-navbar">
        <Container className="d-flex justify-content-between align-items-center">
          {/* Logo only visible on mobile (hidden on desktop) */}
          <Navbar.Brand href='/' >
            <img src={LogoHeader} alt="Logo" className="navbar-logo" />
          </Navbar.Brand>

          {/* Toggle button only visible on mobile */}
          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} className="d-lg-none" />

          {/* Main Nav visible only on desktop */}
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center d-none d-lg-flex">
            <Nav>
              <Nav.Link as={NavLink} to="/" onClick={handleClose}>Home</Nav.Link>
              <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>About Us</Nav.Link>





              <NavDropdown
                title={
                  <span className="nav-dropdown-toggle" style={{ display: 'flex', alignItems: 'center', gap: '5px', position: 'relative' }}>
                    Services <FaAngleDown style={{ fontSize: '0.7rem' }} />
                  </span>
                }
                id="services-nav-dropdown"
                className={isServicesActive ? 'active' : ''}
                show={showDropdown}
                onClick={handleToggleManually}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >

                <NavDropdown.Item as={NavLink} to="/cleaningservices">
                  <FaBroom style={{ marginRight: "8px" }} />
                  Cleaning Services
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/maintenanceservice">
                  <FaWrench style={{ marginRight: "8px" }} />
                  Maintenance Services
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/civilconstructionser">
                  <FaHardHat style={{ marginRight: "8px" }} />
                  Civil & Construction Services
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/mepservice">
                  <MdOutlinePlumbing style={{ marginRight: "8px" }} />
                  Mechanical, Electrical & Plumbing (MEP)
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/paintingandcoating">
                  <FaPaintRoller style={{ marginRight: "8px" }} />
                  Painting & Coating
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/pestbirdcontrol">
                  <FaBug style={{ marginRight: "8px" }} />
                  Pest & Bird Control
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/manpowerandhousekeeping">
                  <FaUsers style={{ marginRight: "8px" }} />
                  Manpower & Housekeeping
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/fabricationservices">
                  <GiSteelDoor style={{ marginRight: "8px" }} />
                  Fabrication Services
                </NavDropdown.Item>

              </NavDropdown>


              {/* <Nav.Link as={NavLink} to="/teamandmachinery" onClick={handleClose}>Team & Machineries </Nav.Link> */}

              <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>Contact Us</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Offcanvas Sidebar for mobile */}
      <Offcanvas show={showSidebar}
        onHide={handleClose} placement="start"
        className="custom-offcanvas">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <a href="/">
              <img src={LogoHeader} alt="Logo" className="navbar-logo" />
            </a>
          </Offcanvas.Title>

        </Offcanvas.Header>


        <Offcanvas.Body className='offcanvasbody'>
          <Nav className="flex-column">
            <Nav.Link as={NavLink} to="/" onClick={handleClose}>
              <FaHome size={18} className="me-2" /> Home
            </Nav.Link>

            <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>
              <FaInfoCircle size={18} className="me-2" /> About Us
            </Nav.Link>

            <Nav.Link as={NavLink} to="/cleaningservices" onClick={handleClose}>
              <FaBroom size={18} className="me-2" /> Cleaning Services
            </Nav.Link>

            <Nav.Link as={NavLink} to="/maintenanceservice" onClick={handleClose}>
              <FaWrench size={18} className="me-2" /> Maintenance Services
            </Nav.Link>

            <Nav.Link as={NavLink} to="/civilconstructionser" onClick={handleClose}>
              <FaHardHat size={18} className="me-2" /> Civil & Construction Services
            </Nav.Link>

            <Nav.Link as={NavLink} to="/mepservice" onClick={handleClose}>
              <MdOutlinePlumbing size={18} className="me-2" /> MEP Services
            </Nav.Link>

            <Nav.Link as={NavLink} to="/paintingandcoating" onClick={handleClose}>
              <FaPaintRoller size={18} className="me-2" /> Painting & Coating
            </Nav.Link>

            <Nav.Link as={NavLink} to="/pestbirdcontrol" onClick={handleClose}>
              <FaBug size={18} className="me-2" /> Pest & Bird Control
            </Nav.Link>

            <Nav.Link as={NavLink} to="/manpowerandhousekeeping" onClick={handleClose}>
              <FaUsers size={18} className="me-2" /> Manpower & Housekeeping
            </Nav.Link>

            <Nav.Link as={NavLink} to="/fabricationservices" onClick={handleClose}>
              <GiSteelDoor size={18} className="me-2" /> Fabrication Services
            </Nav.Link>

            {/* <Nav.Link as={NavLink} to="/teamandmachinery" onClick={handleClose}>
      <FaCogs size={18} className="me-2" /> Team & Machineries
    </Nav.Link> */}

            <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
              <FaPhoneAlt size={18} className="me-2" /> Contact Us
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>

      </Offcanvas>

    </>
  );
}

export default WebHeader;
